export enum ContributionReportJobsStatus {
  CREATED = 'created',
  PROCESSING = 'processing',
  AGGREGATING = 'aggregating',
  COMPLETED = 'completed',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
}

export class ContributionReportJob {
  id!: string

  // Client public key identifying the company
  clientPublicKey!: string

  // Company name for display purposes
  companyName!: string

  // Year for which the contribution report is generated
  year!: number

  //  Current stage/status: created -> processing -> aggregating -> completed/failed
  status!: ContributionReportJobsStatus

  // Total number of employee worker jobs for this report
  totalWorkerJobs?: number = 0

  // Number of completed employee worker jobs
  completedWorkerJobs?: number = 0

  // Number of failed employee worker jobs
  failedWorkerJobs?: number = 0

  // Number of times the job has been retried
  retryCount?: number = 0

  // S3 key to the final CSV report
  reportUrl?: string

  // Additional metadata (employee count, chunk info, etc.)
  metadata?: any

  // Error message if job failed
  errorMessage?: string

  // When report generation was initiated
  createdAt!: Date

  // Last status update time'
  updatedAt!: Date

  // When worker jobs started processing employees
  processingStartedAt?: Date

  // When aggregation of results began
  aggregationStartedAt?: Date

  // When the report was completed or failed
  completedAt?: Date
}
